import api from '@/services/Http'
import { SYNC_FLOWS } from '@/helpers/upload-flows'

export const getGroups = async data =>
  (await api()).get('/sync/group/import/verify-spreadsheet', { params: data })

export const getProcessedGroups = async data =>
  (await api()).get('/sync/group/processed-files', { params: data })

export const getProcessedGroupsById = async data =>
  (await api()).get(`/sync/group/processed-files/${data}`)

export const getProcessedGroupsRecords = async data =>
  (await api()).get(
    `/sync/group/processed-files/${data.processedFileId}/records`,
    { params: data.params }
  )

// O modal de confirmacao E a confirmacao explicita (decisao do CTO, 2026-10-02):
// so se chega aqui pelo @handleConfirm do ConfirmImportModal. O guard de criacao
// em massa (§2.5) marca o arquivo e o worker so prossegue com
// `data.to.confirmed === true` — sem este body, arquivo sinalizado pelo guard
// confirmava, ia para "importando" e NUNCA importava, em silencio.
export const confirmImportRecords = async data =>
  (await api()).put(`/sync/group/processed-files/${data}/confirm-import`, {
    confirmed: true,
  })

export const rejectImportRecords = async data =>
  (await api()).put(`/sync/group/processed-files/${data}/reject-import`)

export const verifySpreadSheet = async (file, flow) => {
  const formData = new FormData()

  formData.append('file', file)

  // flow no multipart (plano híbrido §3.2.1) SOMENTE quando v2 — sem ele,
  // tenant v2-only (legacyImportEnabled=false) tomaria 410 do gate
  // validateFlowEnabled. A request legada permanece byte-idêntica à
  // develop (R1): o Joi do sync-backend aplica o default 'legacy'.
  if (flow === SYNC_FLOWS.V2) {
    formData.append('flow', flow)
  }

  return (await api()).post('/sync/group/import/verify-spreadsheet', formData)
}

export const sendTabsInformations = async tabsInformations => {
  return (await api()).post('/sync/group/import', tabsInformations)
}
